import { Version } from '@repo/toolkit/types'
import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { Product, ProductFilters, ProductSort } from '../../lib/types/models/product/product'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getProducts(
  input: PaginationRequest<ProductFilters, string, Version, ProductSort> = {}
) {
  if (!input.sort) input.sort = { name: 'asc' }
  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API.products.getAll.url, null), input))
    .get<PaginationResponse<Product>>()
}
